import { hoyISO, sumarDias } from "@/lib/zona";

export const CATEGORIAS_GASTO = [
  { id: "alimentacion", label: "Alimentación", icon: "ShoppingBasket" },
  { id: "restaurantes", label: "Restaurantes", icon: "UtensilsCrossed" },
  { id: "transporte", label: "Transporte", icon: "Bus" },
  { id: "taxi", label: "Taxi / VTC", icon: "CarTaxiFront" },
  { id: "combustible", label: "Gasolina / combustible", icon: "Fuel" },
  { id: "alojamiento", label: "Hotel / alojamiento", icon: "BedDouble" },
  { id: "viajes", label: "Viajes", icon: "Plane" },
  { id: "salud", label: "Gastos personales", icon: "Wallet" },
  { id: "hogar", label: "Hogar", icon: "Home" },
  { id: "compras", label: "Compras", icon: "ShoppingBag" },
  { id: "ocio", label: "Ocio", icon: "Ticket" },
  { id: "cuotas", label: "Cuotas / suscripciones", icon: "CalendarCheck" },
  { id: "otros", label: "Otros", icon: "Receipt" },
];
export const catGasto = (id) => CATEGORIAS_GASTO.find((c) => c.id === id) || CATEGORIAS_GASTO[CATEGORIAS_GASTO.length - 1];

export const eur = (n) => new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: "always" }).format(n || 0);
export const dec2 = (n) => (n === "" || n == null || isNaN(Number(n)) ? "" : Number(n).toFixed(2).replace(".", ","));
export const parseImporte = (v) => {
  const s = String(v ?? "").trim().replace(/\s|€/g, "");
  if (!s) return null;
  const n = Number(/,\d{1,2}$/.test(s) ? s.replace(/\./g, "").replace(",", ".") : s.replace(/,/g, ""));
  return Number.isFinite(n) ? n : null;
};

const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const dmy = (iso) => `${Number(iso.slice(8, 10))} de ${MESES[Number(iso.slice(5, 7)) - 1]} de ${iso.slice(0, 4)}`;
export const fechaGasto = (iso) => (iso ? `${Number(iso.slice(8, 10))} ${MESES[Number(iso.slice(5, 7)) - 1].slice(0, 3)} ${iso.slice(0, 4)}` : "");

const finMes = (y, m) => new Date(Date.UTC(y, m, 0)).getUTCDate();
export const PERIODOS = [["semana", "Esta semana"], ["mes", "Este mes"], ["anterior", "Mes anterior"], ["personalizado", "Personalizado"]];
// Devuelve {desde, hasta, label} en la zona del usuario.
export const rangoPeriodo = (tipo, custom = {}) => {
  const hoy = hoyISO();
  const y = Number(hoy.slice(0, 4)), m = Number(hoy.slice(5, 7));
  if (tipo === "semana") {
    const dow = (new Date(`${hoy}T12:00:00Z`).getUTCDay() + 6) % 7;
    const desde = sumarDias(hoy, -dow), hasta = sumarDias(desde, 6);
    return { desde, hasta, label: `Semana del ${dmy(desde)} al ${dmy(hasta)}` };
  }
  if (tipo === "anterior") {
    const yy = m === 1 ? y - 1 : y, mm = m === 1 ? 12 : m - 1;
    const p = `${yy}-${String(mm).padStart(2, "0")}`;
    return { desde: `${p}-01`, hasta: `${p}-${finMes(yy, mm)}`, label: `${MESES[mm - 1][0].toUpperCase()}${MESES[mm - 1].slice(1)} de ${yy}` };
  }
  if (tipo === "personalizado") {
    const desde = custom.desde || hoy, hasta = custom.hasta && custom.hasta >= desde ? custom.hasta : desde;
    return { desde, hasta, label: `Del ${dmy(desde)} al ${dmy(hasta)}` };
  }
  const p = hoy.slice(0, 7);
  return { desde: `${p}-01`, hasta: `${p}-${finMes(y, m)}`, label: `${MESES[m - 1][0].toUpperCase()}${MESES[m - 1].slice(1)} de ${y}` };
};

// Rango de un mes concreto "AAAA-MM".
export const rangoMes = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return { desde: `${ym}-01`, hasta: `${ym}-${finMes(y, m)}`, label: `${MESES[m - 1][0].toUpperCase()}${MESES[m - 1].slice(1)} de ${y}` };
};
export const mesMas = (ym, n) => {
  const [y, m] = ym.split("-").map(Number);
  const t = y * 12 + (m - 1) + n;
  return `${Math.floor(t / 12)}-${String((t % 12) + 1).padStart(2, "0")}`;
};

export const resumir = (gastos) => {
  const total = gastos.reduce((s, g) => s + g.importe, 0);
  const por = {};
  gastos.forEach((g) => { por[g.categoria] = (por[g.categoria] || 0) + g.importe; });
  return { total, porCategoria: Object.entries(por).sort((a, b) => b[1] - a[1]) };
};

// Persona o elemento asociado (para mostrar y filtrar).
export const asociadoDe = (g, { familyMembers = [], viviendas = [], vehiculos = [], pets = [] }) => {
  const f = (l, id) => l.find((x) => x.id === id);
  return [
    g.family_member_id && f(familyMembers, g.family_member_id) && { key: `persona:${g.family_member_id}`, label: f(familyMembers, g.family_member_id).name, persona: f(familyMembers, g.family_member_id) },
    g.vehiculo_id && f(vehiculos, g.vehiculo_id) && { key: `vehiculo:${g.vehiculo_id}`, label: f(vehiculos, g.vehiculo_id).alias, icon: "Car" },
    g.vivienda_id && f(viviendas, g.vivienda_id) && { key: `vivienda:${g.vivienda_id}`, label: f(viviendas, g.vivienda_id).alias, icon: "Home" },
    g.pet_id && f(pets, g.pet_id) && { key: `mascota:${g.pet_id}`, label: f(pets, g.pet_id).name, icon: "PawPrint" },
  ].filter(Boolean);
};
